import { Injectable } from '@angular/core';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { BehaviorSubject, shareReplay } from 'rxjs';
import { IPrivilegeChecklist } from '../adminsettings/role/role.interface';
import { BaseService } from '@services/base-service.service';
import { EnumVerificationStatus } from '@pages/sales-marketing/program-marketing-legacy/program-marketing.enum';
import { API } from '@config/constants/api.constant';
import { IListDeletedPE } from './distributor-detail/components/tab-product-exclusive/tab-product-exclusive.component';

@Injectable({
  providedIn: 'root',
})
export class DistributorDetailService {
  private privilegeDetailSubject = new BehaviorSubject<IPrivilegeChecklist>({} as IPrivilegeChecklist);

  constructor(private baseService: BaseService, private rolePrivilegeService: RolePrivilegeService) {}

  set SetPrivilegeDetail(data: IPrivilegeChecklist) {
    this.privilegeDetailSubject.next(data);
  }

  get PrivilegeDetail() {
    return this.privilegeDetailSubject.value;
  }

  getDetailPrivilege() {
    this.SetPrivilegeDetail = this.rolePrivilegeService.getDataDetailPrivileges('DISTRIBUTOR', 'DETAIL_DISTRIBUTOR')[0];
  }

  hasDetailPrivilege(tabEnum: string, enumValue: string): boolean {
    return <boolean>this.PrivilegeDetail.child?.some((val) => {
      if (val.name === tabEnum) {
        return val.child.some((value: any) => {
          return value.name === enumValue;
        });
      }
      return false;
    });
  }

  filterSectionsByStatus(data: Record<string, any>, status?: EnumVerificationStatus) {
    if (!status) {
      // for section no changes
      return Object.fromEntries(
        Object.entries(data).filter(([k, value]) => {
          if (data[k as keyof typeof data].hasOwnProperty('revision_data')) {
            return value.revision_data === null && value.revision_note === null && value.status_verified_enum === null;
          }
        })
      );
    }

    return Object.fromEntries(Object.entries(data).filter(([, value]) => value.status_verified_enum === status));
  }

  detailDataIsLoaded = <T>(data: T) => !!(data && Object.keys(data).length);

  sectionKeyAsControlName = (section: object) => Object.keys(section).find((key) => key);

  getDeletedProductExclusive(id: string) {
    return this.baseService.patchData<IListDeletedPE>(API.DISTRIBUTOR.GET_DELETED_PRODUCT_EXCLUSIVE + id).pipe(shareReplay());
  }
}
